import Vue from 'vue';
import Router from 'vue-router';

import { SystemPagesEnum } from './util/signup';
import { clientResolution } from '@/util/client';

Vue.use(Router);

const routerPathSegmentPrefix = clientResolution.routerPathSegmentPrefix;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: routerPathSegmentPrefix + '/success',
      name: SystemPagesEnum.Success,
      component: () => import(/* webpackChunkName: "systempages" */ './views/Success.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/reconsentsuccess',
      name: SystemPagesEnum.ReConsentSuccess,
      component: () => import(/* webpackChunkName: "systempages" */ './views/ReConsentSuccess.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/reconsenterror',
      name: SystemPagesEnum.ReConsentError,
      component: () => import(/* webpackChunkName: "systempages" */ './views/ReConsentError.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/error',
      name: SystemPagesEnum.Error,
      props: true,
      component: () => import(/* webpackChunkName: "systempages" */ './views/Error.vue'),
    },

    {
      path: routerPathSegmentPrefix + '/validisError',
      name: SystemPagesEnum.ValidisError,
      props: true,
        component: () => import(/* webpackChunkName: "systempages" */ './views/ValidisError.vue'),
    },

    {
      path: routerPathSegmentPrefix + '/declined',
      name: SystemPagesEnum.Declined,
      component: () => import(/* webpackChunkName: "systempages" */ './views/Declined.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/cancelled',
      name: SystemPagesEnum.Cancelled,
      component: () => import(/* webpackChunkName: "systempages" */ './views/Cancelled.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/' + SystemPagesEnum.Strategy,
      name: SystemPagesEnum.Strategy,
      props: true,
      component: () => import(/* webpackChunkName: "strategy-page" */ '@/views/Strategy.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/' + SystemPagesEnum.Progress,
      name: SystemPagesEnum.Progress,
      component: () => import(/* webpackChunkName: "progress-page" */ '@/views/Progress.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/' + SystemPagesEnum.ValidisConsent,
      name: SystemPagesEnum.ValidisConsent,
      props: true,
      component: () => import(/* webpackChunkName: validis-consent-page"*/ '@/views/ValidisUserConsent.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/' + SystemPagesEnum.ValidisAreYouSure,
      name: SystemPagesEnum.ValidisAreYouSure,
      props: true,
      component: () => import(/* webpackChunkName: validis-areYouSure-page"*/ '@/views/ValidisAreYouSure.vue'),
    },
    {
     path: routerPathSegmentPrefix + '/' + SystemPagesEnum.Scenario,
     name: SystemPagesEnum.Scenario,
     props: true,
     component: () => import(/* webpackChunkName: scenario-page"*/ '@/views/ScenarioMessage.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/' + SystemPagesEnum.Reconsent,
      name: SystemPagesEnum.Reconsent,
      props: true,
      component: () => import(/* webpackChunkName: reconsent"*/ '@/views/Reconsent.vue'),
    },
    {
      path: routerPathSegmentPrefix + '/mastercard-redirect',
      name: 'MastercardRedirect',
      props: true,
      component: () => import(/* webpackChunkName: "mastercard-redirect"*/ '@/views/MastercardRedirect.vue'),
    }
  ],
});

export default router;
